import { agentV2Request } from '@/agent-v2/conversations/fetch/agent-v2-request'
import { AgencyDocumentSchema, type AgencyDocument } from '@/agent-v2/agency-documents/fetch/agency-document'
import { kAgencyDocumentsApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'

/**
 * Loads an indexed government document for the matter-free viewer.
 * @param documentId The Metascraper document-version ID from an MCP source link.
 * @param signal Cancels the request when the page changes documents.
 * @returns The document's title, URLs, media types, and whether its saved original can be opened.
 */
export async function getAgencyDocumentById(documentId: string, signal?: AbortSignal): Promise<AgencyDocument> {
  return agentV2Request({
    url: `${kPaxtonAppApiRESTBaseUrl()}${kAgencyDocumentsApiBasePath}/${encodeURIComponent(documentId)}`,
    method: 'GET',
    signal,
    sentryEndpoint: 'GET /api/v1/agency-documents/{document_id}',
    // A link to a document that is no longer indexed is an expected outcome, not an incident.
    expectedErrorStatuses: [404],
    parseResponse: (data, { response }) => {
      const parsed = AgencyDocumentSchema.safeParse(data)
      if (!parsed.success) throw new ApiResponsePayloadError(response.status, 'Invalid agency document response', parsed.error.issues)
      return parsed.data
    },
  })
}
